import React from "react";
import { Link } from "react-router-dom";

function CharacterCard({ character }) {
  const fallbackImage = "/images/default.png"; // Path to the placeholder image in `public/images`

  return (
    <div className="character-card">
      <Link to={`/character/${character.id}`} style={{ textDecoration: "none" }}>
        <img
          src={character.image && character.image.trim() ? character.image : fallbackImage} // Use fallback if no image is provided
          alt={character.name || "Unknown Character"}
        />
        <h3>{character.name || "Unknown Character"}</h3>
      </Link>
    </div>
  );
}

export default CharacterCard;

